import { AddShipping, EditShipping, ModifyShipping } from "@/types/address";
import axios from "axios";
const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL;

export const shippingService = {
  // ✅ Add Shipping Address
  async postShipping(data: AddShipping) {
    const response = await axios.post(`${API_BASE_URL}/shipping_address`, data);
    return response.data;
  },

  // ✅ Fetch Shipping Address
  async getShipping(userID: string | null) {
    const response = await axios.get(
      `${API_BASE_URL}/shipping_address/${userID}`
    );
    return response.data;
  },

  // ✅ make dafault Shipping Address
  async modifyShipping(addressData: ModifyShipping) {
    const data = addressData?.data;
    const shippingID = addressData?.shippingID;
    const response = await axios.patch(
      `${API_BASE_URL}/shipping_address/${shippingID}`,
      data
    );
    return response.data;
  },

  // ✅ update Shipping Address
  async patchShipping(addressData: EditShipping) {
    const data = addressData?.data;
    const shippingID = addressData?.shippingID;
    const response = await axios.patch(
      `${API_BASE_URL}/shipping_address/${shippingID}`,
      data
    );
    return response.data;
  },

  // ✅ Delete Shipping Address
  async deleteShipping(shippingID: number) {
    const response = await axios.delete(
      `${API_BASE_URL}/shipping_address/${shippingID}`
    );
    return response.data;
  },
};
